export enum LoanExpenseCategory {
    PreClosing = 0,
    PostClosing = 1,
}
